export default __webpack_public_path__ + "static/media/i205jk.746b3544.webp";